import { HttpService } from '@/services/http.service';

export default {
    async store() {
        return await HttpService.httpPost(`/landing/annual-training`);
    },

    async update(employeeId, completedOnDate) {
        return await HttpService.httpPost(`/admin/annual-trainings/${employeeId}/update`, {completed_on: completedOnDate});
    },
}
